import {Component, Prop, Vue} from "vue-property-decorator";
import {className} from "~/lib/helpers/string";
import {isDefined} from "~/lib/helpers/guards";
import {Icon, icons} from "~/components/icon";

@Component
class Checkbox extends Vue {

  @Prop({type: String, default:null }) label: string;
  @Prop({type: Boolean, required:true}) value: boolean;
  @Prop({type: Boolean, default:false}) disabled: boolean;
  @Prop({type: Boolean, default:false}) static: boolean;

  get isChecked() {
    return this.value === true;
  }

  handleClick(e){

    if(this.disabled || this.static) return;

    e.stopPropagation();
    this.$emit("click");
    this.$emit("input", !this.isChecked);
  }

  render(){
    return (
      <div class={className("checkbox alt", {checked: this.isChecked, disabled: this.disabled})} onClick={this.handleClick}>
        <div class="checkbox_check">
          { this.isChecked ? <Icon icon={icons.check} /> : null}
        </div>
        {isDefined(this.label) ? <label>{this.label}</label> : <div class="checkbox_content">{this.$slots.default}</div> }
      </div>
    );
  }
}

export {Checkbox};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-bb986da2/checkbox.tsx" });